module.exports = new __parcel__URL__("hud_battle_royale_blue_view_button.c4fb4e1e.png").toString();